import { defineComponent as _defineComponent } from 'vue'
import { Subsidiary } from '@/models/subsidiary';
import { subsidiariesService } from '@/services/subsidiaries.service';
import SubsidiaryProperties from './SubsidiaryProperties.vue';
import SubsidiaryUsers from './SubsidiaryUsers.vue';
import { onBeforeMount, reactive } from 'vue';
import { useSpinner } from '@/composables/misc';
import { useRoute } from '@/composables/router';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubsidiaryDetail',
  setup(__props) {

const route = useRoute();
const spinner = useSpinner();
const { t } = useI18n();

const subsidiary = reactive(Subsidiary.GetEmpty());

onBeforeMount(async () => {
  Object.assign(subsidiary, await fetchSubsidiary(+route.value.params.id));
});

async function fetchSubsidiary(id: number): Promise<Subsidiary> {
  spinner.showSpinner();
  try {
    return await subsidiariesService.getById(id);
  } finally {
    spinner.removeSpinner();
  }
}

return { __sfc: true,route, spinner, t, subsidiary, fetchSubsidiary, SubsidiaryProperties, SubsidiaryUsers }
}

})